/**
 * Interface language (rule 9, changed by Bruno on 17/10/2026): each person sees the app in English or French.
 * English text is the key; FR maps it to French. Data (tour names, hotels, notes) is never translated.
 * Placeholders: {name}. Missing French text falls back to English (a test lists what is missing).
 */
import { FR } from './fr.js';
export const LANGS = ['en', 'fr'];
export const LANG_LABELS = { en: 'English', fr: 'Français' };
export const isLang = (v) => v === 'en' || v === 'fr';
export function fill(text, vars) {
    if (!vars)
        return text;
    return text.replace(/\{(\w+)\}/g, (m, k) => (k in vars ? String(vars[k]) : m));
}
export function translate(lang, text, vars) {
    return fill(lang === 'fr' ? (FR[text] ?? text) : text, vars);
}
export const translator = (lang) => (text, vars) => translate(lang, text, vars);
/** English, used where no person is involved (logs, tests). */
export const en = translator('en');
export { FR };
//# sourceMappingURL=i18n.js.map